<template>
  <div class="formTilteBox">
    <h3 class="title">
      <span>{{title}}</span>
      <svg class="msgIcon" aria-hidden="true" @click="lookStep(false)">
        <use xlink:href="#iconwenhaoxiao" />
      </svg> 
    </h3>
    <step v-if="!isLookStep" @close="lookStep"></step>
  </div>
</template>

<script>
export default {
  props:['title'],
  data() {
    return {
      isLookStep: localStorage.getItem("isLookStep"), //存缓存,
    }
  },
  created() {},
  methods: {
    //认证步骤关闭
    lookStep(data) {
      this.isLookStep = data;
    },
  },
};
</script>

<style scoped lang="scss">
.formTilteBox {
  .title {
    position: relative;
    display: flex;
    align-items: center;
    height: 100px;
    padding-left: 49px;
    font-size: 24px;
    font-weight: bold;
    line-height: 100%;
    color: rgba(201, 193, 153, 1);
    background: url(~@/assets/img/console/titleBg.jpg) no-repeat #28252c;
    background-position: 70% 0;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 33px;
      width: 5px;
      height: 24px;
      transform: translateY(-50%);
      border-radius: 3px;
      background: #ded094;
    }
    .msgIcon {
      margin: 0 64px 0 12px;
      width: 18px;
      height: 18px;
      cursor: pointer;
        &:hover{
        transform:scale(1.5);
      }
    }
  }
}    
</style>
